import {Box, Grid, TextField, Typography} from "@mui/material";

const FormProspect = (
    {
        values = {},
        handlerOnChange = () => {
        },
        handlerOnChangeSelectMulti = () => {

        },
        newController = () => {
        },
        selfLabelInput = () => {

        },
        origins = [],
        trainingGoals = [],
        spacing = 2,
    }
) => {
    let originNames = [];
    origins.map((origin) => originNames.push(origin.name));
    return (
        <Grid container spacing={spacing}>
            <Grid item xs={12} mb={1}>
                <Typography variant={'h6'} mb={3}>
                    ¿Cómo nos conociste?
                </Typography>
                <Grid container>
                    {origins.map((origin, index) => (
                        <Grid item xs={4} key={`origin-${index}`}>
                            <Box className={`gridItem ${
                                values.origin_lead === origin.id ? "selected" : ""
                            }`}
                                 onClick={() => handlerOnChange(
                                     {target: {name: 'origin_lead', value: origin.id}}
                                 )}
                            >
                                <span>{origin.name}</span>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
                {values['origin_lead'] && values.origin_lead === 'Otro' && (
                    newController(
                        {
                            name: 'other_origin',
                            render: ({field}) => (
                                <TextField
                                    {...field}
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    placeholder={selfLabelInput('Escribe aquí', true)}
                                    onChange={handlerOnChange}
                                />
                            )
                        }
                    )
                )}
            </Grid>
            <Grid item xs={12}>
                <Typography variant={'h6'} mb={3}>
                    Objetivos de entrenamiento
                </Typography>
                <Grid container>
                    {trainingGoals.map((trainingGoal, index) => (
                        <Grid item xs={4} key={`origin-${index}`}>
                            <Box className={`gridItem ${
                                values.training_goals.includes(trainingGoal.id) ? "selected" : ""
                            }`}
                                 onClick={() => handlerOnChangeSelectMulti(
                                     {target: {name: 'training_goals', value: trainingGoal.id}}
                                 )}
                            >
                                <span>{trainingGoal.name}</span>
                            </Box>
                        </Grid>
                    ))}
                </Grid>

            </Grid>
        </Grid>
    );
}

export {
    FormProspect
}
